import * as THREE from 'three';

/**
 * ショット力インジケーター（手玉から伸びる半透明の色帯）。
 * 自前モジュール（three のみ・**GPL非依存**）。手玉のショット方向ガイド上に、
 * 予測挙動（届かない=黄 / 的玉に届く=青 / STOPになる強さ=緑）を色で重ねる。
 */
export interface ShotGuide {
  /** 1フレーム更新（色帯を手玉位置・方向・長さ・色で配置）。 */
  update(p: {
    readonly originX: number;
    readonly originY: number;
    readonly z: number;
    readonly angle: number;
    readonly length: number; // [m]。0 以下で非表示
    readonly color: number; // 0xRRGGBB
  }): void;
  /** 非表示にする。 */
  hide(): void;
  /** リソース解放。 */
  dispose(): void;
}

const GUIDE_WIDTH_R = 1.4; // 帯の幅 = ballR × これ

export const createShotGuide = (
  scene: THREE.Scene,
  ballR: number,
): ShotGuide => {
  // 単位長(+x方向・長さ1・手前端が原点)の平面。毎フレーム scale.x で長さを変える。
  const geom = new THREE.PlaneGeometry(1, ballR * GUIDE_WIDTH_R);
  geom.translate(0.5, 0, 0); // 原点を手前端へ（手玉位置から前方へ伸ばす）
  const mat = new THREE.MeshBasicMaterial({
    color: 0xffd400,
    transparent: true,
    opacity: 0.4,
    depthTest: false, // ガイドは常に視認できるようクロスに隠れない
    side: THREE.DoubleSide,
  });
  const mesh = new THREE.Mesh(geom, mat);
  mesh.renderOrder = 2; // helper(renderOrder=-1) より前面
  mesh.visible = false;
  scene.add(mesh);

  return {
    update({ originX, originY, z, angle, length, color }) {
      if (!(length > 1e-3)) {
        mesh.visible = false;
        return;
      }
      mesh.visible = true;
      mat.color.setHex(color);
      mesh.position.set(originX, originY, z);
      mesh.rotation.z = angle;
      mesh.scale.x = length;
    },
    hide() {
      mesh.visible = false;
    },
    dispose() {
      scene.remove(mesh);
      geom.dispose();
      mat.dispose();
    },
  };
};
